import {css} from "@emotion/css";
import {PieChart, Pie, Legend, Tooltip, Cell} from "recharts";
import React from "react";

const SimplePieChart = () => {
    const data01 = [
        { name: "تعداد کاربر آنلاین", value: 1000000 },
        { name: "تعداد کل کاربران", value: 300000 },
        { name: "گزارش سوم", value: 200000 },
        { name: "گزارش چهارم", value: 100000 },
    ];

    const data02 = [
        { name: "گزارش اول", value: 2400 },
        { name: "گزارش دوم", value: 4567 },
        { name: "گزارش سوم", value: 1398 },
        { name: "گزارش چهارم", value: 9800 },
        { name: "گزارش پنجم", value: 3908 },
        { name: "گزارش ششم", value: 4800 }
    ];
    const COLORS = ["var(--color-purple)", 'var(--color-green)', 'var(--color-red)', 'var(--color-blue)'];
  return(
      <div className={css`width: 100%;height: 100%;direction: ltr`}>
          <PieChart width={1000} height={400}>
              <Pie
                  dataKey="value"
                  isAnimationActive={true}
                  data={data01}
                  cx={200}
                  cy={200}
                  outerRadius={100}
                  fill="#8884d8"
                  label
              >
              {data01.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
              </Pie>
              <Pie
                  dataKey="value"
                  data={data02}
                  cx={500}
                  cy={200}
                  innerRadius={40}
                  outerRadius={80}
                  fill="#252525"
              />
              <Tooltip />
          </PieChart>

      </div>
  )
}
export default SimplePieChart